module.exports = __webpack_public_path__ + "static/img/icon_matron5.5787d6e1.png";